<!-- ワンタッチパスコンポーネント -->
<template>
    <div class="regist">
        <template v-if="!isRegistration">
            <slot name="note"></slot>
            <div v-if="isError" class="aCt errNote">
                <p>このワンタッチパスは解除できません。<br>解除を希望される場合は大変お手数ですが発行元クラブへお問合せ下さい。</p>
            </div>
            <passes @toggle-element="toggle"
                    @show-error="showError"
                    :userinfo="userinfo"
                    :csrf-name="dataCsrfName"
                    :csrf="dataCsrf"
                    :token="dataToken"
                    :is-visible="isRegistration"></passes>
        </template>
        <template v-else>
            <p>お手持ちのワンタッチパスID（クラブ発行会員番号）の情報を入力してください。</p>
            <regist @toggle-element="toggle"
                    :is-visible="isRegistration"></regist>
        </template>
    </div>
</template>

<script>
import RegistOneTouchForm from './OneTouch/RegistOneTouchForm'
import OneTouchListForm from './OneTouch/OneTouchListForm'

export default {
    name: 'OneTouch',
    components: {
        'regist': RegistOneTouchForm,
        'passes': OneTouchListForm
    },
    data: function(){
        return {
            userInfoPatch: {},
            jsonPatchObserver: {},
            jsonPatchForUserInfo: '',
            isRegistration: false,
            isError: false
        }
    },
    props: {
        dataCsrf: {
            type: String,
            required: true
        },
        dataCsrfName: {
            type: String,
            required: true
        },
        dataToken: {
            type: String,
            required: true
        },
        userinfo: {
            type: Object,
            required: true
        }
    },
    methods: {
        toggle: function(value){
            // 子コンポーネントのボタンから親の表示を切り替える
            this.isRegistration = value;

            // ChangeUserinfo コンポーネントの見出しを切り替える
            this.$emit('add-one-touch-pass', this.isRegistration);
        },
        showError: function (value) {
            this.isError = value;
        }
    }
}
</script>
